import React, { useState } from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

import {
  FaUser,
  FaHeart,
  FaShoppingBag,
  FaMapMarkerAlt,
  FaSignOutAlt,
  FaCheckCircle,
  FaBox,
  FaTruck,
  FaHome,
} from "react-icons/fa";

const steps = [
  {
    icon: <FaCheckCircle />,
    label: "Order Confirmed",
    date: "20 Apr 2026, 10:32 AM",
    desc: "Your order has been placed successfully.",
    done: true,
  },
  {
    icon: <FaBox />,
    label: "Processing",
    date: "21 Apr 2026, 02:15 PM",
    desc: "Your jewellery is being carefully packed.",
    done: true,
  },
  {
    icon: <FaTruck />,
    label: "Shipped",
    date: "22 Apr 2026, 09:00 AM",
    desc: "Dispatched via BlueDart — AWB: BD8840012345",
    done: true,
    active: true,
  },
  {
    icon: <FaHome />,
    label: "Out for Delivery",
    date: "Expected: 23 Apr 2026",
    desc: "Your package will arrive soon.",
    done: false,
  },
  {
    icon: <FaCheckCircle />,
    label: "Delivered",
    date: "—",
    desc: "Package delivered to your doorstep.",
    done: false,
  },
];

const TrackOrder = () => {
  const [searchId, setSearchId] = useState("NS-1045");
   const [menuOpen, setMenuOpen] =  useState(false);

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        <Header />

        <link rel="stylesheet" href="/assets/css/TrackOrder.css" />

        {/* BREADCRUMB */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage: "url('/assets/img/bg/breadcumb-bg-1.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />
          <div className="container">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Track Order</h1>
              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li><Link to="/">Home</Link></li>
                  <li>Track Order</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* MAIN SECTION */}
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row g-4">

              {/* SIDEBAR */}
              <div className="col-lg-3">
                <div className="account-sidebar">
                  <div className="account-user text-center">
                    <div className="account-avatar">
                      <img src="/assets/img/author/author-1-1.png" alt="User" />
                    </div>
                    <h5>Priya Sharma</h5>
                    <p>priya@email.com</p>
                  </div>
                  <ul className="account-nav">
                    <li>
                      <Link to="/my-account" className="account-nav__link">
                        <FaUser /> My Profile
                      </Link>
                    </li>
                    <li>
                      <Link to="/my-orders" className="account-nav__link active">
                        <FaShoppingBag /> My Orders
                      </Link>
                    </li>
                    <li>
                      <Link to="/wishlist" className="account-nav__link">
                        <FaHeart /> Wishlist
                      </Link>
                    </li>
                    <li>
                      <Link to="/address" className="account-nav__link">
                        <FaMapMarkerAlt /> Addresses
                      </Link>
                    </li>
                    <li>
                      <Link to="/login" className="account-nav__link logout-link">
                        <FaSignOutAlt /> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-9">

                {/* SEARCH BAR */}
                <div className="track-search-bar">
                  <div className="track-search-inner">
                    <input
                      type="text"
                      className="track-input"
                      placeholder="Enter Order ID (e.g. NS-1045)"
                      value={searchId}
                      onChange={(e) => setSearchId(e.target.value)}
                    />
                    <button className="vs-btn track-search-btn">
                      Track
                    </button>
                  </div>
                </div>

                {/* ORDER INFO HEADER */}
                <div className="track-order-header">
                  <div className="track-order-meta">
                    <div className="tom-left">
                      <h3 className="tom-id">Order #NS-1045</h3>
                      <span className="tom-date">Placed: 20 Apr 2026</span>
                    </div>
                    <span className="track-status-badge shipped">SHIPPED</span>
                  </div>

                  <div className="track-eta-box">
                    <span className="eta-label">Estimated Delivery</span>
                    <span className="eta-date">23 April 2026</span>
                    <span className="eta-carrier">
                      <FaTruck className="me-1" />
                      BlueDart &nbsp;|&nbsp; AWB: <strong>BD8840012345</strong>
                    </span>
                  </div>
                </div>

                {/* PROGRESS STEPPER */}
                <div className="track-card mt-4">
                  <h4 className="track-section-title">Order Progress</h4>

                  <div className="track-stepper">
                    {steps.map((step, i) => (
                      <div
                        key={i}
                        className={`track-step ${step.done ? "done" : ""} ${step.active ? "active" : ""}`}
                      >
                        <div className="step-connector-wrap">
                          <div className="step-icon">{step.icon}</div>
                          {i < steps.length - 1 && (
                            <div className={`step-line ${step.done ? "done" : ""}`} />
                          )}
                        </div>
                        <div className="step-info">
                          <h5 className="step-label">{step.label}</h5>
                          <p className="step-date">{step.date}</p>
                          <p className="step-desc">{step.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* PRODUCTS + DELIVERY SIDE-BY-SIDE */}
                <div className="track-two-col mt-4">

                  {/* PRODUCTS */}
                  <div className="track-card flex-1">
                    <h4 className="track-section-title">Items in this Order</h4>

                    <div className="track-product-item">
                      <img src="/assets/img/product3/product-s-1-1.png" alt="" />
                      <div>
                        <p className="tp-name">Petal Perfection Ring</p>
                        <p className="tp-meta">Qty: 1 &nbsp;|&nbsp; ₹4,500</p>
                      </div>
                      <span className="tp-price">₹4,500</span>
                    </div>

                    <div className="track-product-item border-0">
                      <img src="/assets/img/product3/product-s-1-3.png" alt="" />
                      <div>
                        <p className="tp-name">Diamond Stud Earrings</p>
                        <p className="tp-meta">Qty: 1 &nbsp;|&nbsp; ₹6,800</p>
                      </div>
                      <span className="tp-price">₹6,800</span>
                    </div>

                    <div className="track-total-row">
                      <span>Order Total</span>
                      <strong>₹11,300</strong>
                    </div>
                  </div>

                  {/* DELIVERY ADDRESS */}
                  <div className="track-card track-address-card">
                    <h4 className="track-section-title">Delivery Address</h4>

                    <div className="address-block">
                      <p className="addr-name">Priya Sharma</p>
                      <p>42, Lotus Avenue, Banjara Hills</p>
                      <p>Hyderabad – 500034</p>
                      <p>Telangana, India</p>
                      <p className="addr-phone">📞 +91 98765 43210</p>
                    </div>

                    <div className="carrier-info mt-3">
                      <p><FaTruck className="me-1 text-primary" /> <strong>BlueDart Express</strong></p>
                      <p className="awb-text">AWB No: BD8840012345</p>
                      <a
                        href="https://www.bluedart.com"
                        target="_blank"
                        rel="noreferrer"
                        className="vs-btn mt-3 cancel-red-btn cancel-red-btn-custom cancel-red-btn"
                      >
                        Track on BlueDart
                      </a>
                      
                    </div>
                  </div>

                </div>

                {/* BOTTOM BUTTONS */}
                <div className="track-footer-btns mt-4">
                  <Link to="/my-orders" className="vs-btn style2 cancel-red-btn cancel-red-btn ">
                    ← Back to Orders
                  </Link>
                  <Link to="/shop" className="vs-btn cancel-red-btn-continue">
                    Continue Shopping
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default TrackOrder;
